// extracted by mini-css-extract-plugin
module.exports = {"button_group":"JoinMindTrust6_button_group__2JgID","add_more":"JoinMindTrust6_add_more__2_f3L","label":"JoinMindTrust6_label__12_do"};